import React from 'react';
import './AIResume.css';
import smartcvImage from '../Images/Airesume.jpg';
import { Link } from 'react-router-dom';

const SmartCVModern = () => {
  return (
    <div className="cv-section-wrapper">
      {/* Left Side */}
      <div className="cv-section-left">
        <h1 className="cv-heading">
          <span className="cv-line-black">SmartCV – The Smarter </span>
          <span className="cv-line-blue">Way to Build Resumes</span>
        </h1>

        <p className="cv-description">
          Create impactful, job-winning resumes with AI-powered suggestions, real-time feedback,
          and modern templates – all at your fingertips.
        </p>

        <div className="cv-feature-grid">
          <div className="cv-feature-item">🤖 AI-Suggested Content</div>
          <div className="cv-feature-item">🎨 Designer Templates</div>
          <div className="cv-feature-item">📈 Real-Time Optimization</div>
          <div className="cv-feature-item">📤 Export to PDF & DOCX</div>
        </div>

        <div className="cv-button-group">
          <Link to= "/SignupForm"> 
          <button className="cv-btn primary">Get Started Free</button></Link>
          <button className="cv-btn outline">Book Free Demo</button>
        </div>

        <div className="cv-trusted-text">
          💼 Trusted by 10,000+ job seekers worldwide.
        </div>
      </div>

      {/* Right Side */}
      <div className="cv-section-right">
        <img src={smartcvImage} alt="AI Resume Illustration" className="cv-image" />
      </div>
    </div>
  );
};

export default SmartCVModern;
